var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 17,
    viewBox: "0 0 194 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000004594"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 22",
    y1: -0.5,
    x2: 19.4165,
    y2: -0.5,
    transform: "matrix(-0.566529 0.824042 -0.962563 -0.271058 11.5 0.210938)",
    stroke: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 23",
    y1: -0.5,
    x2: 19.4165,
    y2: -0.5,
    transform: "matrix(-0.566529 0.824042 -0.962563 -0.271058 18.5 0.210938)",
    stroke: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 24",
    y1: -0.5,
    x2: 19.4165,
    y2: -0.5,
    transform: "matrix(-0.566529 0.824042 -0.962563 -0.271058 25.5 0.210938)",
    stroke: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 25",
    y1: -0.5,
    x2: 19.4165,
    y2: -0.5,
    transform: "matrix(-0.566529 0.824042 -0.962563 -0.271058 32.5 0.210938)",
    stroke: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 26",
    y1: -0.5,
    x2: 19.4165,
    y2: -0.5,
    transform: "matrix(-0.566529 0.824042 -0.962563 -0.271058 39.5 0.210938)",
    stroke: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 27",
    y1: -0.5,
    x2: 19.4165,
    y2: -0.5,
    transform: "matrix(-0.566529 0.824042 -0.962563 -0.271058 46.5 0.210938)",
    stroke: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 28",
    y1: -0.5,
    x2: 19.4165,
    y2: -0.5,
    transform: "matrix(-0.566529 0.824042 -0.962563 -0.271058 53.5 0.210938)",
    stroke: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 29",
    y1: -0.5,
    x2: 19.4165,
    y2: -0.5,
    transform: "matrix(-0.566529 0.824042 -0.962563 -0.271058 60.5 0.210938)",
    stroke: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 30",
    y1: -0.5,
    x2: 19.4165,
    y2: -0.5,
    transform: "matrix(-0.566529 0.824042 -0.962563 -0.271058 67.5 0.210938)",
    stroke: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 31",
    y1: -0.5,
    x2: 19.4165,
    y2: -0.5,
    transform: "matrix(-0.566529 0.824042 -0.962563 -0.271058 74.5 0.210938)",
    stroke: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 32",
    y1: -0.5,
    x2: 19.4165,
    y2: -0.5,
    transform: "matrix(-0.566529 0.824042 -0.962563 -0.271058 81.5 0.210938)",
    stroke: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 33",
    y1: -0.5,
    x2: 19.4165,
    y2: -0.5,
    transform: "matrix(-0.566529 0.824042 -0.962563 -0.271058 88.5 0.210938)",
    stroke: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 34",
    y1: -0.5,
    x2: 19.4165,
    y2: -0.5,
    transform: "matrix(-0.566529 0.824042 -0.962563 -0.271058 94.5 0.210938)",
    stroke: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 35",
    y1: -0.5,
    x2: 19.4165,
    y2: -0.5,
    transform: "matrix(-0.566529 0.824042 -0.962563 -0.271058 101.5 0.210938)",
    stroke: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 36",
    y1: -0.5,
    x2: 19.4165,
    y2: -0.5,
    transform: "matrix(-0.566529 0.824042 -0.962563 -0.271058 108.5 0.210938)",
    stroke: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 37",
    y1: -0.5,
    x2: 19.4165,
    y2: -0.5,
    transform: "matrix(-0.566529 0.824042 -0.962563 -0.271058 115.5 0.210938)",
    stroke: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 38",
    y1: -0.5,
    x2: 19.4165,
    y2: -0.5,
    transform: "matrix(-0.566529 0.824042 -0.962563 -0.271058 122.5 0.210938)",
    stroke: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 39",
    y1: -0.5,
    x2: 19.4165,
    y2: -0.5,
    transform: "matrix(-0.566529 0.824042 -0.962563 -0.271058 129.5 0.210938)",
    stroke: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 40",
    y1: -0.5,
    x2: 19.4165,
    y2: -0.5,
    transform: "matrix(-0.566529 0.824042 -0.962563 -0.271058 136.5 0.210938)",
    stroke: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 41",
    y1: -0.5,
    x2: 19.4165,
    y2: -0.5,
    transform: "matrix(-0.566529 0.824042 -0.962563 -0.271058 143.5 0.210938)",
    stroke: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 42",
    y1: -0.5,
    x2: 19.4165,
    y2: -0.5,
    transform: "matrix(-0.566529 0.824042 -0.962563 -0.271058 150.5 0.210938)",
    stroke: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 43",
    y1: -0.5,
    x2: 19.4165,
    y2: -0.5,
    transform: "matrix(-0.566529 0.824042 -0.962563 -0.271058 157.5 0.210938)",
    stroke: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 44",
    y1: -0.5,
    x2: 19.4165,
    y2: -0.5,
    transform: "matrix(-0.566529 0.824042 -0.962563 -0.271058 164.5 0.210938)",
    stroke: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 45",
    y1: -0.5,
    x2: 19.4165,
    y2: -0.5,
    transform: "matrix(-0.566529 0.824042 -0.962563 -0.271058 171.5 0.210938)",
    stroke: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 46",
    y1: -0.5,
    x2: 19.4165,
    y2: -0.5,
    transform: "matrix(-0.566529 0.824042 -0.962563 -0.271058 178.5 0.210938)",
    stroke: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 47",
    y1: -0.5,
    x2: 19.4165,
    y2: -0.5,
    transform: "matrix(-0.566529 0.824042 -0.962563 -0.271058 185.5 0.210938)",
    stroke: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 48",
    y1: -0.5,
    x2: 19.4165,
    y2: -0.5,
    transform: "matrix(-0.566529 0.824042 -0.962563 -0.271058 192.5 0.210938)",
    stroke: "#E2E8F0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashes);
export default __webpack_public_path__ + "static/media/dashes.713b462e105f18bcfeb3cb532b78d1a0.svg";
export { ForwardRef as ReactComponent };